
import { Component, Vue } from 'vue-property-decorator'
import ActivateMessage from '@/components/templates/activate/ActivateMessage.vue'

/**
 * ユーザ有効化登録完了ページ
 */
@Component({
  components: {
    ActivateMessage,
  },
})
export default class ActivateComplete extends Vue {
  /**
   * 生徒ログイン画面への遷移処理
   */
  private async eventSubmit(): Promise<void> {
    await this.$router.push('/student/login')
  }
}
